import heic2any from 'heic2any'

export const heicChange = async (file) => {
  let fileName = file.name.toLowerCase().replace('.heic','.jpg')
  let res = await heic2any({
    blob: file,
    toType: 'image/jpg'
  })
  let changeFile = new File([res], fileName ,{type:'image/jpeg', lastModified:new Date().getTime()})
  return changeFile
}